import { TAction } from './types/action';

// Action Types
export const LOAD_ADD_GUILD_DATA_FROM_LOCAL_STORAGE = 'LOAD_ADD_GUILD_DATA_FROM_LOCAL_STORAGE';
export const SET_ADD_GUILD_PARAMS = 'SET_ADD_GUILD_PARAMS';
export const TOGGLE_OPEN_GUILD_DETAILS_TABLE = 'TOGGLE_OPEN_GUILD_DETAILS_TABLE';
export const SET_GUILD_DETAILS_TABLE_BOSS_RANKINGS = 'SET_GUILD_DETAILS_TABLE_BOSS_RANKINGS';
export const SET_GUILD_BOSS_KILL_DETAILS = 'SET_GUILD_BOSS_KILL_DETAILS';
export const SET_GUILD_BOSS_KILL_FORCE_REFRESH = 'SET_GUILD_BOSS_KILL_FORCE_REFRESH';
export const SHOW_GUILD_BOSS_KILL_LOADING_SPINNER = 'SHOW_GUILD_BOSS_KILL_LOADING_SPINNER';
export const DEFAULT_RAID_CATEGORY_TO_OPEN = 'SET_GUILD_DETAILS_RAID_CATEGORY_OPEN';
export const SET_SELECTED_GUILD_KILL_VIDEO = 'SET_SELECTED_GUILD_KILL_VIDEO';

export type TAddGuildParams = {
  type: string;
  region: string;
  realm: string;
  name: string;
  numMembers?: number;
  realmId: number;
};

// Action Creator
const GuildActionCreator = {
  loadAddGuildDataFromLocalStorage(): TAction<undefined> {
    return {
      type: LOAD_ADD_GUILD_DATA_FROM_LOCAL_STORAGE,
      payload: undefined
    };
  },

  setAddGuildParams(params: Partial<TAddGuildParams>): TAction<Partial<TAddGuildParams>> {
    return {
      type: SET_ADD_GUILD_PARAMS,
      payload: params
    };
  },

  defaultRaidCategoryToOpen(raid: string, difficulty: string): TAction<any> {
    return {
      type: DEFAULT_RAID_CATEGORY_TO_OPEN,
      payload: { raid, difficulty }
    };
  },
  toggleOpenGuildDetailsTable(raid: string, difficulty: string): TAction<any> {
    return {
      type: TOGGLE_OPEN_GUILD_DETAILS_TABLE,
      payload: {
        raid,
        difficulty
      }
    };
  },

  setGuildDetailsTableBossRankings(raid: string, difficulty: string, guildId: number, bossRankings: any[]) {
    return {
      type: SET_GUILD_DETAILS_TABLE_BOSS_RANKINGS,
      payload: {
        raid,
        difficulty,
        guildId,
        bossRankings
      }
    };
  },

  setGuildBossKillDetails(key: string, details: any) {
    return {
      type: SET_GUILD_BOSS_KILL_DETAILS,
      payload: {
        key,
        details
      }
    };
  },

  setGuildBossKillVideo(key: string, video: any) {
    return {
      type: SET_SELECTED_GUILD_KILL_VIDEO,
      payload: {
        key,
        video
      }
    };
  },

  setGuildBossKillForceRefresh(key: string) {
    return {
      type: SET_GUILD_BOSS_KILL_FORCE_REFRESH,
      payload: {
        key
      }
    };
  },

  showGuildBossKillDetailsLoadingSpinner(key: string, show: boolean) {
    return {
      type: SHOW_GUILD_BOSS_KILL_LOADING_SPINNER,
      payload: {
        key,
        show
      }
    };
  }
};

export default GuildActionCreator;
